import { forwardRef } from 'react'

import { getTextFromReactNode } from '@/utils/functions/helpers/getTextFromReactNode'
import type { SelectProps, SelectRefType } from '../Select'
import { Select } from '../Select'

export type SearchSelectProps = SelectProps & {
  match?: 'label' | 'value' | 'both'
}

export const SearchSelect = forwardRef<SelectRefType, SearchSelectProps>(
  ({ match = 'both', options, ...props }, ref) => {
    return (
      <Select
        ref={ref}
        filterOption={(inputValue: string, option) => {
          if (!option || option.value === null || option.value === undefined) {
            return false
          }

          const { label, value } = option

          const valueString = String(value).toLowerCase()
          const labelString = getTextFromReactNode(label).toLowerCase()
          const inputValueString = inputValue.toLowerCase()

          if (match === 'label') {
            return labelString.includes(inputValueString)
          }

          if (match === 'value') {
            return valueString.includes(inputValueString)
          }

          return labelString.includes(inputValueString) || valueString.includes(inputValueString)
        }}
        options={options}
        showSearch
        {...props}
      />
    )
  },
)
SearchSelect.displayName = 'SearchSelect'
